import * as React from "react";
import { MapPin, Clock, Navigation } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurHeadquarters() {
  return <section data-section-id="243448" id="our-headquarters" className="bg-background text-foreground relative w-full h-[600px] lg:h-[700px] overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/beacon_finance_hq_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/beacon_finance_hq_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/beacon_finance_hq_map.png-wvc-sizes" alt="Beacon Finance Group Headquarters Location" className="w-full h-full object-cover grayscale opacity-90" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-background/20 mix-blend-multiply"></div>
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center group cursor-pointer">
        <div className="relative">
          {}
          <div className="absolute -inset-4 bg-primary/20 rounded-lg animate-ping opacity-75"></div>
          <div className="absolute -inset-2 bg-primary/40 rounded-lg animate-pulse"></div>
          {}
          <div className="relative bg-background border-2 border-primary text-primary p-3 rounded-lg shadow-lg transition-transform duration-300 group-hover:scale-110">
            <MapPin className="w-8 h-8" />
          </div>
        </div>
        <div className="mt-2 px-3 py-1 bg-background/95 backdrop-blur-md border border-border rounded-md shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-sm font-default font-bold tracking-tight text-primary">BEACON HQ</span>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 left-4 right-4 md:left-12 md:right-auto md:bottom-1/2 md:translate-y-1/2 md:w-[400px] z-20">
        <Card className="bg-card/95 backdrop-blur-md border-primary/5 shadow-4xl rounded-md">
          <CardHeader>
            <CardTitle className="text-2xl font-default font-bold text-primary tracking-tight">Our Headquarters</CardTitle>
            <CardDescription className="text-foreground/70 font-default">
              Guiding your path to homeownership.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start space-x-4">
              <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <div>
                <h4 className="font-default font-semibold text-primary">Office Address</h4>
                <p className="text-sm text-foreground/80 mt-1 font-default">
                  1200 Financial District Plaza, Suite 400<br />
                  Charlotte, NC 28202
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <Clock className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <div>
                <h4 className="font-default font-semibold text-primary">Advisory Hours</h4>
                <div className="text-sm text-foreground/80 mt-1 space-y-1 font-default">
                  <p>Mon-Fri: 8:00 AM - 6:00 PM</p>
                  <p>Sat: By Appointment Only</p>
                </div>
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button asChild className="w-full group bg-primary hover:bg-primary/90 text-primary-foreground rounded-md" size="lg">
              <Link to="https://maps.google.com/?q=Charlotte+NC+Financial+District" newTab>
                <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}